(() => {
  const KEY = 'EasyGamesDigitalBadgePolicyV1';
  if (window[KEY]) return;
  window[KEY] = true;

  const CONFIG_SELECTOR = '[data-eg-digital-config]';
  const norm = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const list = (value) => String(value || '').split(',').map(norm).filter(Boolean);

  const config = () => {
    const node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return null; }
  };

  const patch = () => {
    const engine = window.__easyGamesBadgeEngineV6;
    if (!engine || engine.__egDigitalBadgePolicyV1) return;

    const originalMatch = engine.match.bind(engine);
    engine.match = function digitalAwareMatch(rule, data) {
      if (rule?.t === 'special_order') {
        const cfg = config();
        const enabled = cfg?.enabled !== false && cfg?.preventSpecialAuto !== false;
        if (enabled && data?.g instanceof Set && data.g.has('digital')) {
          const overrideTags = list(cfg?.specialOverrideTags || 'import');
          const hasOverride = overrideTags.some((tag) => data.g.has(tag));
          if (!hasOverride) return false;
        }
      }
      return originalMatch(rule, data);
    };

    engine.__egDigitalBadgePolicyV1 = true;
    engine.all?.();
  };

  const run = () => {
    patch();
    window.setTimeout(patch, 40);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.addEventListener('load', run, { once: true });
  document.addEventListener('shopify:section:load', () => window.setTimeout(run, 0));
})();
